const ID = 'highlight';

export default ID;
